import { TumorBoard } from './tumorBoard'

export { TumorBoard }
